import React from 'react'
import {
  Composer,
  Panel,
  useSticky,
  useScrollToEnd
} from 'react-scroll-to-bottom'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'
import IconButton from '@material-ui/core/IconButton'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  btn: {
    bottom: 50,
    left: '85%',
    position: 'relative'
  }
}))

const AutoHideFollowButton = ({ children, className }) => {
  const [sticky] = useSticky()
  const scrollToEnd = useScrollToEnd()
  const classes = useStyles()

  return (
    !sticky && (
      <IconButton className={classes.btn} onClick={scrollToEnd} type="button">
        <ArrowDownwardIcon />
      </IconButton>
    )
  )
}

const CustomScrollToBottom = ({
  checkInterval,
  children,
  className,
  debounce,
  followButtonClassName,
  mode,
  scrollViewClassName
}) => (
  <Composer checkInterval={checkInterval} debounce={debounce} mode={mode}>
    <div className={className}>
      <Panel className={scrollViewClassName}>{children}</Panel>
      <AutoHideFollowButton className={followButtonClassName} />
    </div>
  </Composer>
)

export default CustomScrollToBottom
